"use strict";const e=require("styled-components").css`
    width: 100%;
    text-align: center;
    padding: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: ${({isInline:e})=>e?"relative":"fixed"};
    top: 0;
    left: 0;
    background: ${({theme:e})=>e.colors.light};
    z-index: -1;
    transition: all 0.4s ease-in-out;
    animation: ${({isLoading:e,isLoaded:t})=>e?"loading_enter .1s":"loading_exit "+(t?".2s":"0s")}
        ease-in-out forwards;

    svg {
        color: ${({theme:e})=>e.colors.primary.default};
        width: 170px;
        height: auto;

        .house--front {
            stroke: ${({theme:e})=>e.colors.primary.dark};
            stroke-dasharray: 365;
            animation: dash 3s ease-in-out infinite;
        }

        .cloud {
            &--left,
            &--right {
                animation: bob 1s ease-in-out infinite alternate;
            }

            &--left {
                animation-delay: -0.5s;
            }
        }
    }

    @keyframes loading_enter {
        0% {
            z-index: 100;
            opacity: 0;
        }
        100% {
            z-index: 100;
            opacity: 1;
        }
    }

    @keyframes loading_exit {
        0% {
            z-index: 100;
            opacity: 1;
        }
        99% {
            z-index: 100;
            opacity: 0;
        }
        100% {
            z-index: -1;
            opacity: 0;
        }
    }

    @keyframes dash {
        from {
            stroke-dashoffset: -365;
        }
        to {
            stroke-dashoffset: 365;
        }
    }

    @keyframes bob {
        from {
            transform: translateY(5px);
        }
        to {
            transform: translateY(0);
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
